/*
  Himalayas Shop – bowl sound samples (replaces Osaria Audio Player)
  HS: customisation 5 (see himalayas-theme-customisations register)

  Sounds live in Shopify Files and are linked with metafields:
    - variant.metafields.custom.sound_sample  (per size)
    - product.metafields.custom.sound_sample  (default / single sound)

  One shared <audio> for the whole page, so only one sound plays at a time.
  Any element with [data-hs-sound-src] reflects state via classes:
    .is-current  .is-playing   and CSS var --hs-p (0..1 progress)
*/
(function () {
  if (window.HSSound) return;

  var audio = new Audio();
  audio.preload = 'none';
  var current = null;

  function fmt(t) {
    if (!isFinite(t)) t = 0;
    t = Math.max(0, Math.floor(t || 0));
    return Math.floor(t / 60) + ':' + ('0' + (t % 60)).slice(-2);
  }

  function sync() {
    var playing = !audio.paused && !audio.ended;
    var p = audio.duration ? audio.currentTime / audio.duration : 0;
    var els = document.querySelectorAll('[data-hs-sound-src]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var on = !!current && el.getAttribute('data-hs-sound-src') === current;
      el.classList.toggle('is-current', on);
      el.classList.toggle('is-playing', on && playing);
      el.style.setProperty('--hs-p', on ? p : 0);
      if (el.tagName === 'BUTTON') el.setAttribute('aria-pressed', on && playing ? 'true' : 'false');
    }
    document.dispatchEvent(new CustomEvent('hs:sound', {
      detail: { src: current, playing: playing, progress: p, time: audio.currentTime, duration: audio.duration }
    }));
  }
  ['play', 'pause', 'ended', 'timeupdate', 'loadedmetadata', 'durationchange', 'error'].forEach(function (ev) {
    audio.addEventListener(ev, sync);
  });

  function toggle(src) {
    if (!src) return;
    if (current === src && !audio.paused && !audio.ended) { audio.pause(); return; }
    if (current !== src) { current = src; audio.src = src; }
    else if (audio.ended) { audio.currentTime = 0; }
    var pr = audio.play();
    if (pr && pr.catch) pr.catch(function () { sync(); });
    sync();
  }
  function play(src) {
    if (current === src && !audio.paused && !audio.ended) return;
    toggle(src);
  }

  window.HSSound = { toggle: toggle, play: play, pause: function () { audio.pause(); }, audio: audio, fmt: fmt, sync: sync, current: function () { return current; } };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  // ---------- collection cards (delegated: works with AJAX filters / load more) ----------
  function cardItem(card) { return card.closest('[data-grid-item]') || card.parentNode; }
  function cardOption(card) {
    var s = card.querySelector('[data-hs-card-select]');
    return s ? s.options[s.selectedIndex] : null;
  }
  // reflect the chosen size: label, play source, card price, links and the theme's Add to cart button
  function applyCardSize(card) {
    var opt = cardOption(card); if (!opt) return;
    var item = cardItem(card);
    var txt = card.querySelector('[data-hs-card-size-text]'); if (txt) txt.textContent = opt.getAttribute('data-short');
    var play = card.querySelector('[data-hs-card-play]');
    if (opt.getAttribute('data-sound')) play.setAttribute('data-hs-sound-src', opt.getAttribute('data-sound'));
    var priceEl = item.querySelector('.product-item__price');
    if (priceEl) {
      var cmp = opt.getAttribute('data-compare');
      priceEl.innerHTML = opt.getAttribute('data-available') === 'true'
        ? '<span class="price' + (cmp ? ' sale' : '') + '"><span class="new-price">' + esc(opt.getAttribute('data-price')) + '</span>' + (cmp ? ' <span class="old-price">' + esc(cmp) + '</span>' : '') + '</span>'
        : '<span class="price"><span class="sold-out">Sold out</span></span>';
    }
    var base = card.getAttribute('data-hs-url');
    if (base) {
      [].forEach.call(item.querySelectorAll('a[data-product-link], a.product-link'), function (a) {
        a.setAttribute('href', base + '?variant=' + opt.value);
        if (a.hasAttribute('data-product-link')) a.setAttribute('data-product-link', a.getAttribute('href'));
      });
    }
    [].forEach.call(item.querySelectorAll('[data-quick-add-btn]'), function (btn) {
      var t = btn.querySelector('.btn__text');
      if (t) t.textContent = 'Add ' + opt.getAttribute('data-short');
      btn.setAttribute('aria-label', 'Add ' + opt.getAttribute('data-short') + ' to cart');
    });
  }
  function initCards(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-hs-card]'), function (card) {
      if (card.dataset.hsCardReady) return;
      card.dataset.hsCardReady = '1';
      if (card.querySelector('[data-hs-card-select]')) applyCardSize(card);
    });
  }
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-hs-card-select]');
    if (!sel) return;
    var card = sel.closest('[data-hs-card]');
    var wasPlaying = !audio.paused && !audio.ended && current === card.querySelector('[data-hs-card-play]').getAttribute('data-hs-sound-src');
    applyCardSize(card);
    if (wasPlaying) play(card.querySelector('[data-hs-card-play]').getAttribute('data-hs-sound-src'));
    else sync();
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    // keep taps on the size picker from opening the product
    if (e.target.closest('[data-hs-card] .hs-card__size')) { e.stopPropagation(); return; }
    var p = e.target.closest('[data-hs-card-play]');
    if (p) { e.preventDefault(); e.stopPropagation(); toggle(p.getAttribute('data-hs-sound-src')); return; }
    // the card's Add to cart: add the size chosen in the bar straight to the cart (instead of the quick-view pop-up)
    var qa = e.target.closest('[data-quick-add-btn]');
    if (!qa) return;
    var item = qa.closest('[data-grid-item]'); if (!item) return;
    var card = item.querySelector('[data-hs-card]'); var opt = card && cardOption(card);
    if (!opt) return;
    e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (opt.getAttribute('data-available') !== 'true') return;
    addVariant(parseInt(opt.value, 10), qa);
  }, true);
  function addVariant(id, btn) {
    var routes = (window.theme && window.theme.routes) || {};
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    fetch((routes.cart_add_url || rootUrl + 'cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () { return fetch(rootUrl + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { cart: cart, cartCount: cart.item_count } }));
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.openCartDrawer === 'function') setTimeout(function () { drawer.openCartDrawer(); }, 250);
        else window.location.href = routes.cart_url || rootUrl + 'cart';
      })
      .catch(function (err) {
        var t = btn.querySelector('.btn__text'); if (!t) return;
        var old = t.textContent;
        t.textContent = (err && err.description && /sold out|not available|quantity/i.test(err.description)) ? 'Sold out' : 'Try again';
        setTimeout(function () { t.textContent = old; }, 2200);
      })
      .finally(function () { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); });
  }
  document.addEventListener('hs:sound', function (e) {
    var d = e.detail || {};
    var cards = document.querySelectorAll('[data-hs-card]');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      var mine = d.src && c.querySelector('[data-hs-card-play]').getAttribute('data-hs-sound-src') === d.src;
      var pr = c.querySelector('[data-hs-card-progress]'), tm = c.querySelector('[data-hs-card-time]');
      if (pr) pr.style.width = (mine ? (d.progress || 0) * 100 : 0) + '%';
      if (tm) tm.textContent = mine ? fmt(d.time) : '0:00';
      c.classList.toggle('is-playing', !!(mine && d.playing));
    }
  });
  // cards can arrive later (filters, load more): set them up as they appear
  if (window.MutationObserver) {
    var cardTimer = null;
    new MutationObserver(function () {
      if (cardTimer) return;
      cardTimer = setTimeout(function () { cardTimer = null; initCards(); }, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  // ---------- product page ----------

  var PLAY_SVG = '<svg viewBox="0 0 16 16" aria-hidden="true" class="hs-ico-play"><path d="M5 3.5v9l7-4.5z"/></svg>';
  var PAUSE_SVG = '<svg viewBox="0 0 16 16" aria-hidden="true" class="hs-ico-pause"><path d="M4.5 3.5h2.5v9H4.5zM9 3.5h2.5v9H9z"/></svg>';

  function initProduct(root) {
    if (root.dataset.hsReady) return;
    root.dataset.hsReady = '1';
    var data;
    try { data = JSON.parse(root.querySelector('[data-hs-sound-data]').textContent); } catch (err) { return; }
    var section = root.closest('.shopify-section') || document;
    var head = root.querySelector('[data-hs-sound-head]');
    var hint = root.querySelector('[data-hs-sound-hint]');
    var strip = root.querySelector('[data-hs-sound-strip]');
    var mainBtn = root.querySelector('[data-hs-sound-main]');
    var label = root.querySelector('[data-hs-sound-label]');
    var time = root.querySelector('[data-hs-sound-time]');
    var bar = root.querySelector('[data-hs-sound-bar]');
    // several recordings of one product (e.g. soft side / wooden side): one button each
    var tracksBox = root.querySelector('[data-hs-tracks]');
    var hasTracks = !!(tracksBox && data.tracks && data.tracks.length > 1);
    var chosenTrack = null;
    function trackLabel(src) {
      if (!tracksBox) return '';
      var b = tracksBox.querySelectorAll('[data-hs-track]');
      for (var i = 0; i < b.length; i++) if (b[i].getAttribute('data-hs-sound-src') === src) return b[i].getAttribute('data-hs-track-label') || '';
      return '';
    }

    function form() { return section.querySelector('form[data-product-form]') || section.querySelector('form[data-type="add-to-cart-form"]'); }
    function variantId() {
      var f = form(); var input = f && f.querySelector('input[name="id"]');
      var id = input && parseInt(input.value, 10);
      return id || data.selected;
    }
    function variant(id) {
      for (var i = 0; i < data.variants.length; i++) if (data.variants[i].id === id) return data.variants[i];
      return data.variants[0];
    }

    // Which option values get a play segment: every variant with that value must share the same own sound.
    var chipMap = [];
    data.options.forEach(function (name, i) {
      var byValue = {};
      data.variants.forEach(function (v) {
        var val = v.options[i];
        if (!(val in byValue)) byValue[val] = v.sound || null;
        else if (byValue[val] !== (v.sound || null)) byValue[val] = false;
      });
      var map = {}, count = 0;
      Object.keys(byValue).forEach(function (val) { if (byValue[val]) { map[val] = byValue[val]; count++; } });
      chipMap.push(count ? map : null);
    });
    var chipOption = -1, best = 0;
    chipMap.forEach(function (m, i) {
      if (!m) return;
      var n = Object.keys(m).length;
      var distinct = Object.keys(m).map(function (k) { return m[k]; }).filter(function (u, j, a) { return a.indexOf(u) === j; }).length;
      if (distinct > 1 && n > best) { best = n; chipOption = i; }
    });
    var perSize = chipOption >= 0;
    root.classList.toggle('hs-per-size', perSize);
    // per-size products: the player bar stays hidden until a size is played
    if (strip) strip.classList.toggle('hs-await', perSize || hasTracks);

    function sizeInputs() {
      var out = [];
      if (!perSize) return out;
      var name = data.options[chipOption] + '-' + (chipOption + 1);
      var inputs = section.querySelectorAll('.radio__button input[type="radio"]');
      for (var i = 0; i < inputs.length; i++) {
        // Broadcast's names can carry a trailing newline from a Liquid capture, so compare trimmed
        if (String(inputs[i].name).trim() === name) out.push(inputs[i]);
      }
      return out;
    }
    function labelFor(input) {
      return (input.labels && input.labels[0]) || (input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL' ? input.nextElementSibling : null);
    }

    // Turn each size button into [ ▶ | 6 - 7 inch ] and place heading above / player bar below the sizes
    function decorate() {
      var inputs = sizeInputs();
      if (!inputs.length) return;
      // if the theme re-rendered the picker from HTML, drop any copied heading / bar that aren't ours
      [].forEach.call(section.querySelectorAll('[data-hs-sound-head], [data-hs-sound-strip]'), function (el) {
        if (el !== head && el !== strip) el.parentNode.removeChild(el);
      });
      var container = inputs[0].closest('[data-variant-buttons]') || inputs[0].closest('.radio__buttons');
      if (container) {
        container.classList.add('hs-sizes');
        // Broadcast lays out [legend | buttons] as a grid, so keep heading + buttons + bar together in one column
        var col = container.parentNode;
        if (!col.classList.contains('hs-size-col')) {
          col = document.createElement('div');
          col.className = 'hs-size-col';
          container.parentNode.insertBefore(col, container);
          col.appendChild(container);
        }
        if (head && col.firstElementChild !== head) col.insertBefore(head, col.firstChild);
        if (strip && container.nextElementSibling !== strip) col.insertBefore(strip, container.nextSibling);
      }
      inputs.forEach(function (input) {
        var src = chipMap[chipOption][String(input.value).trim()];
        var lab = labelFor(input);
        if (!lab || !src) return;
        lab.setAttribute('data-hs-sound-src', src);
        lab.classList.add('hs-has-chip');
        if (!lab.querySelector('[data-hs-chip]')) {
          var chip = document.createElement('span');
          chip.className = 'hs-chip';
          chip.setAttribute('data-hs-chip', '');
          chip.setAttribute('aria-hidden', 'true');
          chip.innerHTML = PLAY_SVG + PAUSE_SVG;
          lab.insertBefore(chip, lab.firstChild);
        }
      });
      sync();
    }

    function soundFor(v) { return v.sound || chosenTrack || data.productSound || null; }
    function render() {
      var v = variant(variantId());
      var src = soundFor(v);
      if (!src) { root.hidden = true; if (head) head.hidden = true; if (strip) strip.hidden = true; return; }
      root.hidden = false;
      if (head) head.hidden = false;
      if (strip) strip.hidden = false;
      mainBtn.setAttribute('data-hs-sound-src', src);
      var size = perSize && v.sound ? v.options[chipOption] : (hasTracks && !v.sound ? trackLabel(src) : '');
      label.innerHTML = size ? '<b>' + esc(size) + '</b><span class="hs-sound__sfx"> sample</span>' : 'Hear this bowl';
      if (hint) hint.textContent = perSize ? 'Tap a size to hear it' : (hasTracks ? 'Tap each one to hear it' : '');
      sync();
    }

    mainBtn.addEventListener('click', function () { toggle(mainBtn.getAttribute('data-hs-sound-src')); });

    if (hasTracks) {
      tracksBox.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-hs-track]');
        if (!b) return;
        e.preventDefault();
        chosenTrack = b.getAttribute('data-hs-sound-src');
        render();
        toggle(chosenTrack);
      });
    }

    // tapping anywhere on a size button: the theme selects that size, and we play (or pause) its sound
    section.addEventListener('click', function (e) {
      var lab = e.target.closest && e.target.closest('label.hs-has-chip');
      if (!lab) return;
      var src = lab.getAttribute('data-hs-sound-src');
      setTimeout(function () { toggle(src); }, 0);
    });

    document.addEventListener('hs:sound', function (e) {
      var d = e.detail || {};
      var mine = d.src && d.src === mainBtn.getAttribute('data-hs-sound-src');
      bar.style.width = (mine ? (d.progress || 0) * 100 : 0) + '%';
      if (mine) {
        time.textContent = fmt(d.time) + (d.duration && isFinite(d.duration) ? ' / ' + fmt(d.duration) : '');
      } else {
        time.textContent = '';
      }
      root.classList.toggle('is-playing', !!(mine && d.playing));
      if (strip) {
        strip.classList.toggle('is-playing', !!(mine && d.playing));
        // per-size products: the bar appears under the sizes once a sound has been started
        if ((perSize || hasTracks) && mine) strip.classList.add('is-active');
      }
    });

    // the theme may re-render the variant picker: re-decorate, follow the selected size
    var t = null, lastVid = null;
    var mo = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () {
        mo.disconnect();
        decorate();
        mo.observe(section, { childList: true, subtree: true });
        var id = variantId(); if (id !== lastVid) { lastVid = id; render(); }
      }, 60);
    });
    section.addEventListener('change', function () { setTimeout(function () { var id = variantId(); if (id !== lastVid) { lastVid = id; render(); } }, 120); }, true);
    setInterval(function () { var id = variantId(); if (id !== lastVid) { lastVid = id; render(); } }, 700);

    decorate();
    lastVid = variantId();
    render();
    mo.observe(section, { childList: true, subtree: true });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-hs-sound-product]');
    for (var i = 0; i < roots.length; i++) initProduct(roots[i]);
    initCards();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);

  // stop sound when the page is hidden (tab switch / app switch on mobile)
  document.addEventListener('visibilitychange', function () { if (document.hidden) audio.pause(); });
})();
